import { render } from "./EmoteMessage.vue?vue&type=template&id=d32d9594&scoped=true"
import script from "./EmoteMessage.vue?vue&type=script&lang=ts"
export * from "./EmoteMessage.vue?vue&type=script&lang=ts"

import "./EmoteMessage.vue?vue&type=style&index=0&id=d32d9594&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d32d9594"

export default script